<div class="circle" [ngStyle]="{'background-color': circleColor}">
    <img *ngIf="!showInitials" src="{{photoUrl}}">

    <div *ngIf="showInitials" class="initials">
        {{initials}}
    </div>
</div>